import axios from 'axios';
import React, { useEffect, useState } from 'react'
import * as CONSTANTS from "../../CONSTANTS";
import Helper from '../utils/Helper';

function ProfileWidgetPayments({user}) {

  const [paymentList, setPaymentList]                 = useState([]);

  useEffect(() => {
    collectListOfPayments();

  },[])

  const collectListOfPayments = async () => {
    try{
      
          const resData = await axios.get(CONSTANTS.API_URL + 'payment/list/v1/check/' + user._id, {
                headers: {
                  token: 'Bearer ' + user.accessToken,
                },
              }
            );     

            console.log(resData);
            setPaymentList(resData.data);

    }catch(err){
      console.log(err);
    }
  }
  return (
    <div className="card shadow-sm h-100">
        <div className="card-body">
            {
              paymentList && 
              paymentList.length > 0 && (
                <div className="table-mb-scroll">
                  <table className="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th>#NO</th>
                      <th>Created</th>
                      <th>Claim</th>
                      <th>Name</th>
                      <th>Title</th>
                      <th>Email</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      paymentList.map((pay, index) => {
                        return <tr key={index}>
                                  <td><strong>{pay.orderId}</strong></td> 
                                  <td>{Helper.formatDate(pay.createdAt)}</td>  
                                  <td>{pay.claimed ? "Complete" : "Pending"}</td>   
                                  <td>{pay.full_name}</td> 
                                  <td>{pay.title}</td>    
                                  <td>{pay.email}</td>    
                               </tr>
                      })
                    }
                  </tbody>
                </table>
                </div>
              )
            }
        </div>
    </div>
  )
}

export default ProfileWidgetPayments